import { render, staticRenderFns } from "./GoodsGroupEdit.vue?vue&type=template&id=71437853&scoped=true"
import script from "./GoodsGroupEdit.vue?vue&type=script&lang=js"
export * from "./GoodsGroupEdit.vue?vue&type=script&lang=js"
import style0 from "./GoodsGroupEdit.vue?vue&type=style&index=0&id=71437853&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71437853",
  null
  
)

export default component.exports